import {
  accountService,
  membershipService,
  userService
} from '@libs/data-access/queries'
import { useLocation } from 'react-router-dom'

import { trackMemberCreated } from '../events'

export const useTrackMemberCreatedInteraction = () => {
  const location = useLocation()
  const currentAccount = accountService.useFetchCurrent()
  const currentMembership = membershipService.membership.useFetchCurrent()
  const currentUser = userService.user.useFetchCurrentUser()

  const trackInteraction = () => {
    const properties = {
      page_source: location.pathname,
      account_id: currentAccount.data?.id,
      subdomain: currentAccount.data?.subdomain,
      user_email: currentUser?.data?.email,
      membership_id: currentMembership?.data?.id
    }

    trackMemberCreated(properties)
  }

  return {
    trackCreation: () => trackInteraction()
  }
}
